import { render, staticRenderFns } from "./YKToDoList.vue?vue&type=template&id=39e856bc&scoped=true&"
import script from "./YKToDoList.vue?vue&type=script&lang=js&"
export * from "./YKToDoList.vue?vue&type=script&lang=js&"
import style0 from "./YKToDoList.vue?vue&type=style&index=0&id=39e856bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e856bc",
  null
  
)

export default component.exports